import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Vercel-like: sharp corners, hairline border, subtle focus ring
        "border border-border/60 placeholder:text-muted-foreground/40 flex field-sizing-content min-h-16 w-full rounded-none bg-background px-3 py-2 text-base outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "hover:bg-muted/10 focus-visible:ring-2 focus-visible:ring-ring/40",
        "aria-invalid:ring-2 aria-invalid:ring-destructive/25 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
